import { render, staticRenderFns } from "./World.vue?vue&type=template&id=8b6ac8d2&"
import script from "./World.vue?vue&type=script&lang=js&"
export * from "./World.vue?vue&type=script&lang=js&"
import style0 from "./World.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports